import { DATA_STATES } from '@/store/consts';

const STATE_KEYS = {
  ITEMS: 'items',
  DATA_STATE: 'dataState',
  LAST_UPDATE_TIME: 'lastUpdateTime',
  ERROR_COUNT: 'errorCount',
  UNIQUE_ID_KEY: 'uniqueIdKey',
};

const state = {
  [STATE_KEYS.UNIQUE_ID_KEY]: 'id',
  [STATE_KEYS.ITEMS]: {},
  [STATE_KEYS.DATA_STATE]: DATA_STATES.NONE,
  [STATE_KEYS.LAST_UPDATE_TIME]: null,
  [STATE_KEYS.ERROR_COUNT]: 0,
};

export {
  state,
  STATE_KEYS,
};
